import { useState } from 'react';

import useBreakpoints, { PartialBreakpointMap } from '@/hooks/use-breakpoints';

import {
  CarouselItem,
  CarouselPerPage,
  CarouselVariant,
} from '@/features/carousel';
import CarouselGrid from '@/features/carousel/components/carousel-grid';
import CarouselPageIndicator from '@/features/carousel/components/carousel-indicators';

export type PaginatedCarouselProps = {
  variant: CarouselVariant.PAGINATED;
  items: CarouselItem[];
  perPage: CarouselPerPage | PartialBreakpointMap<CarouselPerPage>;
  showPagination?: boolean;
};

export default function PaginatedCarousel(props: PaginatedCarouselProps) {
  const [currentPage, setCurrentPage] = useState(0);
  const { currentEntry: perPage } = useBreakpoints(
    typeof props.perPage === 'number' ? { sm: props.perPage } : props.perPage
  );

  const lastPage = Math.ceil(props.items.length / perPage) - 1;

  return (
    <div className='sm-max-w-none mx-auto w-full px-0'>
      <div className='relative flex items-center justify-between'>
        <CarouselGrid
          items={props.items}
          perPage={perPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>

      {props.showPagination && (
        <CarouselPageIndicator
          currentPage={currentPage}
          lastPage={lastPage}
          onClick={setCurrentPage}
        />
      )}
    </div>
  );
}
